"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function create() {
    var gamepad = {};
    var connected = function (e) {
        console.log(e.gamepad);
    };
    var disconnected = function (e) {
        console.log(e.gamepad);
    };
    var start = function () {
        window.addEventListener('gamepadconnected', connected);
        window.addEventListener('gamepaddisconnected', disconnected);
    };
    var update = function () { };
    return {
        getState: function () { return gamepad; },
        start: start,
        update: update
    };
}
exports.default = { create: create };
